/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e8c5644f088e1ff31a28d841f55a86a4ef5f3cae";
